import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// Simple wrapper component for ReactQuill
// The polyfill in reactPolyfill.js handles the findDOMNode compatibility
const QuillEditor = ({ value, onChange, placeholder, modules, style, ...props }) => {
  // Memoize modules to prevent unnecessary re-renders
  const memoizedModules = useMemo(() => modules, [JSON.stringify(modules)]);

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={memoizedModules}
      style={style}
      {...props}
    />
  );
};

export default QuillEditor;
